import { useNavigate } from 'react-router-dom';

/*
  Reusable deep-link helper for notifications.

  A notification can carry an `accion_ruta` (app route) and an `accion_target`
  ('modal' | 'tab' | 'seccion'). When the user clicks a notification body that has
  an action, we navigate to `accion_ruta` appending the query param
  `notifAction=<accion_target>` so the destination page can interpret it on mount
  and open the recognized modal/tab/section.

  The destination page is responsible for reading `notifAction` (and any
  record-identifying param already present in `accion_ruta`, e.g. `cxcId`) via
  `useLocation` and reacting accordingly.
*/

export const useNotificationAction = () => {
  const navigate = useNavigate();

  const handleNotificationAction = (notification) => {
    const ruta = notification?.accionRuta;
    if (!ruta) return false;

    const target = notification?.accionTarget;
    if (!target) {
      navigate(ruta);
      return true;
    }

    const separator = ruta.includes('?') ? '&' : '?';
    navigate(`${ruta}${separator}notifAction=${encodeURIComponent(target)}`);
    return true;
  };

  return { handleNotificationAction };
};
